// extracted by mini-css-extract-plugin
export var strike = "styles-module--strike--ue06T";
export var nav = "styles-module--nav--lxID3";
export var navList = "styles-module--nav-list--5UVUQ";
export var navItem = "styles-module--nav-item--nO+hS";
export var scrolledPast = "styles-module--scrolled-past--i2LFa";
export var heading2 = "styles-module--heading2--U0-Yu";
export var heading3 = "styles-module--heading3--sQdmY";
export var heading4 = "styles-module--heading4--pLJJ+";
export var heading5 = "styles-module--heading5--EVaYZ";